export const PRODUCT_ERROR_CODES = [
  "offline",
  "missing_key",
  "invalid_key",
  "rate_limited",
  "model_unavailable",
  "timeout",
  "cancelled",
  "invalid_response",
  "generation_failed",
  "quota_exceeded",
  "storage_unavailable",
  "storage_corrupt",
  "unsupported_version",
  "migration_failed",
  "stale_revision",
  "read_only",
  "validation_failed",
  "not_found",
] as const;

export type ProductErrorCode = (typeof PRODUCT_ERROR_CODES)[number];

export class ProductError extends Error {
  readonly code: ProductErrorCode;
  readonly retryable: boolean;

  constructor(code: ProductErrorCode, message: string, retryable = false) {
    super(message);
    this.name = "ProductError";
    this.code = code;
    this.retryable = retryable;
  }
}

export function isProductError(error: unknown): error is ProductError {
  return error instanceof ProductError;
}
